// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoclickController from "./autoclick_controller"
application.register("autoclick", AutoclickController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MapController from "./map_controller"
application.register("map", MapController)

import ReportsController from "./reports_controller"
application.register("reports", ReportsController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import DateTimeController from "./datetime_controller"
application.register("datetime", DateTimeController)
